import { FormVmItemConfigType, FormVmValueValidatorType } from '../../../../../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../../../../../infrastructure/utils/form-config.utils';
import { plainText } from '../../../../../../../../../../modules/validators';
import { trimSpacesLeft } from '../../../../../../../../../../modules/formatters';

export const NAME = 'name';

const uniqueNameValidator = (existingNames: string[]): FormVmValueValidatorType => (val: string = '') => {
    const trimmedValue = val.trim();
    const valid = !trimmedValue || !existingNames.some(name => name.trim().toLowerCase() === trimmedValue.toLowerCase());
    const validationMessage = valid ? null : {
        id: 'oe.eventHubs.websiteBuilder.modules.organizationNameNotUnique',
        defaultMessage: 'Organization with name {name} already exists',
        values: { name: trimmedValue },
    };

    return { valid: valid, validationMessage: validationMessage };
};

export const buildSpeakerOrganizationFormConfig = (existingNames: string[]): FormVmItemConfigType[] => buildConfigList({
    [NAME]: {
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short, uniqueNameValidator(existingNames)],
        formatters: [trimSpacesLeft],
    },
});